import { ComponentLibrary } from '../hooks'
import { MUI_PALETTE, NOVA_PALETTE } from './palette'
import { UIPalette } from './palette/uiPalete.type'

const toKebabCase = (value: string) => value.replace(/[A-Z]/g, (char) => `-${char.toLowerCase()}`)
const createCssVarName = (path: string[]) => `--msdk-colors-${path.map(toKebabCase).join('-')}`

function createCssNode(componentLibrary: ComponentLibrary) {
  if (typeof document === 'undefined') {
    return
  }

  let palette!: UIPalette
  if (componentLibrary === 'mui') {
    palette = MUI_PALETTE
  } else if (componentLibrary === 'nova') {
    palette = NOVA_PALETTE
  } else {
    throw new Error('No Component Library set.')
  }

  const declarations: string[] = []

  const walkPalette = (node: unknown, path: string[] = []) => {
    if (typeof node === 'string') {
      declarations.push(`${createCssVarName(path)}: ${node};`)
      return
    }

    if (!node || typeof node !== 'object') {
      return
    }

    Object.entries(node).forEach(([key, value]) => {
      walkPalette(value, [...path, key])
    })
  }

  walkPalette(palette)

  const styleId = `msdk-colors-${componentLibrary}`
  let styleNode = document.getElementById(styleId) as HTMLStyleElement | null

  if (!styleNode) {
    styleNode = document.createElement('style')
    styleNode.id = styleId
    document.head.appendChild(styleNode)
  }

  styleNode.textContent = `body[data-component-library='${componentLibrary}'] { ${declarations.join(' ')} }`
}

export const appendCssVarsPalette = (componentLibrary: ComponentLibrary) => {
  createCssNode(componentLibrary)
}

const mapPaletteToCssVars = (palette: unknown, path: string[] = []): unknown => {
  if (typeof palette === 'string') {
    return `var(${createCssVarName(path)})`
  }

  if (!palette || typeof palette !== 'object') {
    return palette
  }

  return Object.fromEntries(
    Object.entries(palette).map(([key, value]) => [key, mapPaletteToCssVars(value, [...path, key])]),
  )
}

// Note: we are using NOVA_PALETTE as reference but all palettes implement UIPalette
export const COLORS = mapPaletteToCssVars(NOVA_PALETTE) as UIPalette
